import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=13d7f4e1&"
import script from "./ArticlePage.vue?vue&type=script&lang=coffee&"
export * from "./ArticlePage.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports